<template>
  <ul class="sm-action-requests">
    <li
      v-for="key in Object.keys(actionRequests)"
      :key="key"
      :class="{
        'active': key == currentRequest
      }"
      @click="filterList(key)"
      @mouseenter="handleMouseEnter($event, requestsData[key])"
      @mouseleave="$emit('hideHint')"
    >
    <include-svg :name="requestsData[key].icon" />
      <!-- <hint-wrap 
        :text="requestsData[key].text"
        :horizontal="true"
        :delay="0"
      >
        <template slot="content">
          <include-svg :name="requestsData[key].icon" />
        </template>
      </hint-wrap> -->
      <span class="sm-txt-strong">{{(requests[key] < 100) ? requests[key] : '99+'}}</span>
    </li>
  </ul>
</template>

<script>
import RequestsData from '@/settings/action-requests-data';
import {ToUpper} from '@/utils/general-data';
import HintWrap from '@/components/HintWrap';

export default {
  name: 'action-requests',
  components: {
    'hint-wrap': HintWrap
  },
  props: {
    requests: {
      type: Object,
      default: () => new Object()
    }
  },
  data() {
    return {
      requestsData: RequestsData,
      actionRequests: {},
      allowedRequestNames: [
        'expedited_forward_number',
        'same_day_scan_number',
        'two_days_scan_number',
        'envelope_picture_number',
        'forward_number',
        'mark_as_pick_up_number',
        'pick_up_number',
        'scans_number',
        'shred_number',
        'trash_number',
        'mark_as_junk_number',
        'check_deposit_number',
        'stored_number'
      ]
    };
  },
  computed: {
    currentRequest() {
      let res = null;

      if (!this.$route.query.shortcut)
        return res;

      return Object.keys(this.actionRequests).find(key => RequestsData[key].shortcut == this.$route.query.shortcut)
    }
  },
  created() {
    this.filterRequests();
  },
  methods: {
    toUpper: ToUpper,
    filterRequests() {
      this.actionRequests = {};
      this.allowedRequestNames.forEach(name => {
        if (this.requests[name])
          this.actionRequests[name] = this.requests[name];
      });

      if (this.$route.query.shortcut && !this.currentRequest)
        this.$emit('action', '');
    },
    filterList(key) {
      let split = key.split('_number');
      let res = split[0];

      if (res == 'scans')
        res = 'scan'

      if (res != 'mark_as_junk' && res != "stored")
        res = res + '_requested';

      this.$emit('action', res);
    },
    handleMouseEnter(event, item) {
      // Get the current element
      this.$emit('showHint', item, event);
    },
  },
  watch: {
    requests() {
      this.filterRequests();
    }
  }
}
</script>
